import { useCrmStore } from "../../stores/crm";
import { Input } from "../ui/inputs/Input";
import { Select } from "../ui/inputs/Select";

const PersonneMoral = () => {
  const { formData, setFormData, juridicsForm } = useCrmStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="w-full h-auto bg-white flex justify-around">
      <Input
        label="Numéro de dossier"
        name="number"
        value={formData.number || ""}
        onChange={handleChange}
        clasName="w-1/2 mr-4"
      />
      <Input
        label="Dénomination"
        name="name"
        value={formData.name || ""}
        onChange={handleChange}
        clasName="w-1/2 mr-4"
      />
      <Select
        label="Forme juridique"
        name="juridicForm"
        value={formData.juridicForm || ""}
        onChange={handleSelectChange}
        fetchOptions={juridicsForm}
        className="w-1/2"
      />
    </div>
  );
};

export default PersonneMoral;
